import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Menu from "./components/layout/menu/Menu";
import Topbar from "./components/layout/topbar/Topbar";
import Header from "./components/layout/header/Header";
import Routing from "./services/Routing";
import "./App.css";
import GetData from "./services/getData";
import Preloader from "./components/layout/preload/Preloader";
import Auth from "./Auth";
import UserSettingsProvider from "./context/UserSettingsContext";
import AnketaPublic from "./modules/patient/AnketaPublic";
import { ChatProvider } from "./modules/chat/ChatContext";
import ChatDrawer from "./modules/chat/ChatDrawer";
import AiAssistantProvider from "./modules/ai_assistant/AiAssistantContext";
import AiAssistantPanel from "./modules/ai_assistant/AiAssistantPanel";

function App() {
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showPreloader, setShowPreloader] = useState(true);

  useEffect(() => {
    const fetchPatients = async () => {
      try {
        const data = await GetData({
          module: "patient",
          block: "list",
        });
        setPatients(data.result);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPatients();
  }, []);

  // console.log(patients);

  const [tokenVerification, setTokenVerification] = useState(false);
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(() => {
    try {
      return localStorage.getItem("menuCollapsed") === "true";
    } catch (err) {
      return false;
    }
  });

  const toggleMenuCollapse = () => {
    setIsMenuCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem("menuCollapsed", String(next));
      } catch (err) {
        // localStorage может быть недоступен — не критично
      }
      return next;
    });
  };

  const getAuthInfo = async () => {
    const result = await GetData({ module: "auth", block: "check" });
    let user = result?.user || null;

    // Настройки пользователя берём из auth/check; если сервер их не отдал
    // (например, служба ещё не перезапущена и отдаёт старый check), запрашиваем
    // отдельно — чтобы язык/фильтры подхватывались при любом раскладе.
    if (result?.result === "Y" && user && !user.settings) {
      try {
        const profile = await GetData({
          module: "settings",
          block: "profile",
          action: "get",
        });
        if (profile && profile.success) {
          user = { ...user, settings: profile.settings || {} };
        }
      } catch (err) {
        console.error("Не удалось загрузить настройки пользователя:", err);
      }
    }

    setTokenVerification({
      result: result.result,
      user,
    });
  };

  useEffect(() => {
    getAuthInfo();
    console.log("--------------");
  }, []);

  const handlePreloaderComplete = () => {
    setShowPreloader(false);
    // Здесь можно добавить логику, которая выполнится после завершения прелоадера
    console.log("Preloader completed!");
  };

  // Публичная анкета (/anketa/<token>) — отдаётся без авторизации.
  const isAnketaRoute =
    typeof window !== "undefined" &&
    /^\/anketa\//.test(window.location.pathname || "");

  if (isAnketaRoute) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/anketa/:token" element={<AnketaPublic />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    );
  }

  if (tokenVerification) {
    if (tokenVerification?.result && tokenVerification.result === "Y") {
      return (
        <BrowserRouter>
          <UserSettingsProvider settings={tokenVerification?.user?.settings}>
            <ChatProvider>
              <AiAssistantProvider>
                <div className="app-bg" aria-hidden="true" />
                {/* <Header client={tokenVerification} />*/}
                {showPreloader && (
                  <Preloader onComplete={handlePreloaderComplete} />
                )}
                <div
                  className={`main_content ${isMenuCollapsed ? "menu-collapsed" : ""}`}>
                  <Menu
                    client={tokenVerification}
                    onLogout={getAuthInfo}
                    isCollapsed={isMenuCollapsed}
                    onToggleCollapse={toggleMenuCollapse}
                  />
                  <Topbar client={tokenVerification} />
                  <Routing  client={tokenVerification} patients={patients} />
                </div>
                <ChatDrawer />
                <AiAssistantPanel />
              </AiAssistantProvider>
            </ChatProvider>
          </UserSettingsProvider>
        </BrowserRouter>
      );
    } else {
      return (
        <>
          <div className="app-bg" aria-hidden="true" />
          <Auth onSuccess={getAuthInfo} />
        </>
      );
    }
  }
}

export default App;
